import React from "react";
import withDataTable from "common/components/withDataTable";
import { getPerformanceModules } from "services/performance_module";


const pathName = "/performance/performance-module";
const columns = [
   {
      title: "Module",
      dataIndex: "title",
      key: "title",
      render: title => <div dangerouslySetInnerHTML={{ __html: title }} />
   }
];

const size = new URLSearchParams(document.location.search).get("size");
const current = new URLSearchParams(document.location.search).get("current");
let defaultCurrent = 1;
let defaultPageSize = 20;

if (current) {
   defaultCurrent = current;
}

if (size) {
   defaultPageSize = size;
}

const getData = () => {
   return getPerformanceModules();
};


export default withDataTable({
   title: "Performance Modules",
   permission: "performance module",
   addViewLink: "/performance/performance-module/list",
   topFilterItems: [],
   showFilter: false,
   showAddNew: false,
   showButtonInfo: true,
   showButtonDelete: false,
   showButtonUpdate: false,
   showButtonSearch: false,
   showPagination: false,
   columns,
   pathName,
   defaultCurrent,
   defaultPageSize,
   getData,
});
